import React from 'react';
import { 
	Modal, 
	ModalHeader, 
	ModalBody, 
	ModalFooter, 
	ListGroup, 
	ListGroupItem, 
} from 'reactstrap';
// TOAST

import 'react-toastify/dist/ReactToastify.min.css';
import AssetList from '../table/AssetList.js'

export default class ModalDetailSite extends React.Component {
	constructor(props){
		super(props)
		this.state={
			selectedItem : null
		}
    // console.log(this);
	}
	shouldComponentUpdate(nextProps, nextState) {
	  	if(nextProps.selectedItem != null ){
	  		nextState.selectedItem = nextProps.selectedItem;
	  		return true;
	  	}
  	return false;
	}

	jobStock(){
		const {selectedItem} = this.state
    	this.props.history.push((window.ReactNativeWebView ? "/single-page" : "") + "/job/job-stock-check/" + selectedItem.Alias +"/"+ selectedItem.Name)
	}

	willUnMount(){
		this.props.dontRender()
	}

	render(){
		if(this.state.selectedItem == null){
			return(null)
		}
		return(
		<Modal isOpen={this.props.modalDetail} /*onEnter={()=>this.willMount()}*/ onExit={()=> this.willUnMount()} toggle={this.props.closeModalDetail} className="modal-lg">
	      <ModalHeader toggle={this.props.closeModalDetail}>
	      	{'Site Information'}
	      </ModalHeader>
	      <ModalBody>
	      	<div className="row">
	      		<div className="col-md-12">
	      			<ListGroup>
	      				<div className="row">
							<div className="col-md-6">
								<ListGroupItem className="list-border-bottom">
									<strong className="spaceRRR">Site Name</strong><span>{this.state.selectedItem.Name}</span>
								</ListGroupItem>
							</div>
							<div className="col-md-6">
								<ListGroupItem className="list-border-bottom">
									<strong className="spaceRRR">Alias</strong><span>{this.state.selectedItem.Alias}</span>
								</ListGroupItem>
							</div>
  						</div>
		      			<div className="row">
							<div className="col-md-6">
  								<ListGroupItem className="list-border-bottom">
  									<strong className="spaceRRR">Address</strong><span>{this.state.selectedItem.Address}</span>
  								</ListGroupItem>
							</div>
							<div className="col-md-6">
  								<ListGroupItem className="list-border-bottom">
  									<strong className="spaceRRR">Address 2</strong><span>{this.state.selectedItem.Address2}</span>
  								</ListGroupItem>
							</div>
  						</div>
	  						<div className="row">
  								<div className="col-md-6">
	  								<ListGroupItem className="list-border-bottom">
	  									<strong className="spaceRRR">City</strong><span>{this.state.selectedItem.City.Name}</span>
	  								</ListGroupItem>
  								</div>
  								<div className="col-md-6">
	  								<ListGroupItem className="list-border-bottom">
	  									<strong className="spaceRRR">Status</strong><span>{this.state.selectedItem.Status.Name}</span>
	  								</ListGroupItem>
  								</div>
  							</div>
  							<div className="row">
  								<div className="col-md-6">
	  								<ListGroupItem className="list-border-bottom">
	  									<strong className="spaceRRR">Tag</strong><span>{this.state.selectedItem.Tag}</span>
	  								</ListGroupItem>
  								</div>
  								<div className="col-md-6">
	  								<ListGroupItem className="list-border-bottom">
	  									<strong className="spaceRRR">Project</strong><span>{this.state.selectedItem.ProjectName}</span>
	  								</ListGroupItem>
  								</div>
  							</div>
  							<div className="row">
  								<div className="col-md-6">
	  								<ListGroupItem className="list-border-bottom">
	  									<strong className="spaceRRR">Type</strong><span>{this.state.selectedItem.Type.Name}</span>
	  								</ListGroupItem>
  								</div>
  								<div className="col-md-6">
	  								<ListGroupItem className="list-border-bottom">
	  									<strong className="spaceRRR">Description</strong><span>{this.state.selectedItem.Description}</span>
	  								</ListGroupItem>
  								</div>
  							</div>
  							<div className="space">
  							</div>
  							{/*<ListGroupItem className="list-border-bottom">
  								<strong className="spaceRRR">Description</strong><span>{this.state.selectedItem.Description}</span>
  							</ListGroupItem>*/}
	      			</ListGroup>
	      		</div>
	      	</div>
	      	<div className="row">
	      		<div className="col-md-12 m-top-15">
              { this.props.selectedItem && this.props.selectedItem.Status.Name !== this.props.inactiveName && (
                <button 
                  className="btn btn-primary btn-sm btn-abs-right"
                  onClick={() => this.jobStock()}
                >Stock Taking
                </button>
              )}
	      			<AssetList 
	      				history={this.props.history} 
	      				UserReducer={this.props.UserReducer} 
	      				selectedItem={this.state.selectedItem} 
	      			/>
	      		</div>
	      	</div>

	      </ModalBody>
	      <ModalFooter>
	      	<button type="button" className="btn btn-danger" onClick={this.props.closeModalDetail}>Close</button>
	      </ModalFooter>
	    </Modal>
		)
	}

}


// WEBPACK FOOTER //
// ./src/App/topmenu/job/helper/component/modal/ModalDetailSite.js